import { useQueryClient } from 'react-query'
import { useInvalidateGetValueMessageLinkedDataQuery } from '../../../shared/queries/useInvalidateGetValueMessageLinkedDataQuery'

export const useInvalidateGetValueNarrativesQuery = () => {
    const queryClient = useQueryClient()

    const { invalidateGetValueMessageLinkedDataQuery } = useInvalidateGetValueMessageLinkedDataQuery()

    const invalidateGetValueNarrativesQuery = async () => {
        await queryClient.refetchQueries({
            queryKey: 'valueNarratives',
            exact: false,
        })
        await invalidateGetValueMessageLinkedDataQuery()
    }

    return { invalidateGetValueNarrativesQuery }
}
